import { render, staticRenderFns } from "./groupBuildingList.vue?vue&type=template&id=50b1ca62"
import script from "./groupBuildingList.vue?vue&type=script&lang=js"
export * from "./groupBuildingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports